import { useAdminStore } from '~/stores/useAdminStore'
import type { AdminProfile } from '~/types/admin'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/support')) return

  const requestFetch = useRequestFetch()
  const adminStore = useAdminStore()
  try {
    const me = await requestFetch<{ admin: AdminProfile }>('/api/admin/me')
    adminStore.applyMe(me.admin)
    adminStore.hydrated = true
    if (!['owner', 'admin', 'support'].includes(me.admin.role)) {
      adminStore.reset()
      return navigateTo('/auth/login')
    }
  } catch {
    adminStore.reset()
    adminStore.hydrated = true
    return navigateTo('/auth/login')
  }
})
